import { render, staticRenderFns } from "./MoleculeEditionAssetCard.vue?vue&type=template&id=2cb34e4a&"
import script from "./MoleculeEditionAssetCard.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports